import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = { class: "offline-timeout-setting" }
const _hoisted_4 = { class: "offline-timeout-row" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "offline-timeout-hint" }
const _hoisted_7 = {
  key: 0,
  class: "offline-unlimited-badge"
}
const _hoisted_8 = { class: "save-row" }
const _hoisted_9 = {
  key: 0,
  class: "save-success"
}
const _hoisted_10 = {
  key: 0,
  class: "save-error"
}
const _hoisted_11 = { class: "offline-users-section" }
const _hoisted_12 = {
  key: 0,
  class: "offline-users-loading"
}
const _hoisted_13 = {
  key: 1,
  class: "offline-users-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"card-header\" data-v-6d0cb389><div class=\"card-icon\" data-v-6d0cb389><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-6d0cb389><path d=\"M1 1l22 22\" data-v-6d0cb389></path><path d=\"M16.72 11.06A10.94 10.94 0 0 1 19 12.55\" data-v-6d0cb389></path><path d=\"M5 12.55a10.94 10.94 0 0 1 5.17-2.39\" data-v-6d0cb389></path><path d=\"M10.71 5.05A16 16 0 0 1 22.56 9\" data-v-6d0cb389></path><path d=\"M1.42 9a15.91 15.91 0 0 1 4.7-2.88\" data-v-6d0cb389></path><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\" data-v-6d0cb389></path><line x1=\"12\" y1=\"20\" x2=\"12.01\" y2=\"20\" data-v-6d0cb389></line></svg></div><div data-v-6d0cb389><h3 class=\"card-title\" data-v-6d0cb389>Tempo Offline</h3><p class=\"card-desc\" data-v-6d0cb389>Configure por quantos dias os usuários podem usar o sistema sem conexão com a internet.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "field-label" }, "Limite de dias offline", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            class: "field-input offline-timeout-input",
            type: "number",
            min: "0",
            value: _ctx.form.offlineTimeoutDays ?? 30,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-form', { field: 'offlineTimeoutDays', value: String(($event.target as HTMLInputElement).value) })))
          }, null, 40, _hoisted_5),
          _createElementVNode("span", _hoisted_6, [
            _cache[2] || (_cache[2] = _createTextVNode("dias ", -1)),
            ((_ctx.form.offlineTimeoutDays ?? 30) === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Ilimitado"))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "field-hint" }, "Defina 0 para tempo ilimitado.", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn-save",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2"
          }, [
            _createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
            _createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
            _createElementVNode("polyline", { points: "7 3 7 8 15 8" })
          ], -1),
          _createTextVNode(" Salvar ", -1)
        ]))]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.successText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.successText), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.errorText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errorText), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "offline-users-title" }, "Status dos usuários", -1)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Carregando..."))
          : (_openBlock(), _createElementBlock("table", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Nome"),
                  _createElementVNode("th", null, "Usuário"),
                  _createElementVNode("th", null, "Última conexão"),
                  _createElementVNode("th", null, "Dias offline"),
                  _createElementVNode("th", null, "Status")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRows, (u) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: u.username
                  }, [
                    _createElementVNode("td", null, _toDisplayString(u.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("code", null, _toDisplayString(u.username), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(u.lastOnlineFmt), 1),
                    _createElementVNode("td", null, _toDisplayString(u.daysOffline !== null ? u.daysOffline : '—'), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["offline-status-pill", u.statusClass])
                      }, _toDisplayString(u.statusLabel), 3)
                    ])
                  ]))
                }), 128))
              ])
            ]))
      ])
    ])
  ]))
}